<template>
	<!-- NOTIFICATIONS -->
	<vs-dropdown
		vs-custom-content
		vs-trigger-click
		:fixed="true"
		class="cursor-pointer"
	>
		<feather-icon icon="BellIcon" class="cursor-pointer mt-1 sm:mr-6 mr-2" :badge="unreadNotifications.length"/>

		<vs-dropdown-menu :fixed="true" class="notification-dropdown dropdown-custom vx-navbar-dropdown">

			<div class="notification-top text-center p-5 bg-primary text-white">
				<h3 class="text-white">{{ $t('newMessagesCountDisplay') }}: {{ unreadNotifications.length }}</h3>
				<!--        <p class="opacity-75">App Notifications</p>-->
			</div>

			<component
				:is="scrollbarTag" ref="mainSidebarPs"
				:settings="settings"
				:key="$vs.rtl"
				class="scroll-area--nofications-dropdown p-0 nofications-dropdown"
			>
				<ul class="bordered-items">
					<li v-for="(ntf, index) in unreadNotifications" :key="ntf.id"
						class="flex justify-between px-4 py-4 notification cursor-pointer">
						<div
							@click="redirectToOrder(ntf.order_id)"
							class="flex items-start"
						>
							<feather-icon :icon="'MessageSquareIcon'"
										  :svgClasses="[`text-primary`, 'stroke-current mr-1 h-6 w-6']"></feather-icon>
							<div class="mx-2">
								<span class="font-medium block notification-title break-all hyphens-auto"
									  :class="[`text-primary`]">{{ ntf.title }}</span>
								<small class="break-all hyphens-auto">{{ ntf.message }}</small>
							</div>
						</div>
						<div class="notification__right">
							<small class="mt-1 whitespace-no-wrap">{{ elapsedTime(ntf.created) }}</small>
							<feather-icon
								@click="markAsRead(index)"
								:icon="'XIcon'"
								:svgClasses="[`text-primary`, 'stroke-current mr-1 h-6 w-6']"
								class="notification__close"
							></feather-icon>
						</div>
					</li>
				</ul>

			</component>

			<div @click="markAllAsRead" class="notification-dropdown__markall">
				{{ $t('markAllAsRead') }}
			</div>
		</vs-dropdown-menu>
	</vs-dropdown>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
	components: {
		VuePerfectScrollbar
	},
	data() {
		return {
			count: 0,
			unreadNotifications: [],
			settings: {
				maxScrollbarLength: 60,
				wheelSpeed: .60
			}
		}
	},
	computed: {
		scrollbarTag() {
			return this.$store.getters.scrollbarTag
		}
	},
	async created() {
		if (this.$store.state.auth.role === 'accountant') {
			return
		}

		this.count = (await this.$http.get('/' + this.$store.state.auth.role + '/notification/get-count')).data.data.count;

		await this.getMessages();
		setInterval(async () => await this.getMessages(), 30000);
	},
	methods: {
		async redirectToOrder(orderId) {
			if (orderId !== null && orderId !== true) {
				if (this.$store.state.role === "client") {
					this.$router.push({name: 'order', params: {id: orderId}})
				} else {
					this.$router.push({name: 'TicketsCard', params: {id: orderId}})
				}
			}
			return
		},
		async getMessages() {
			this.unreadNotifications = (await this.$http.get('/'+this.$store.state.auth.role+'/notification')).data.data;
		},
		elapsedTime(startTime) {
			const x = new Date(startTime)
			const now = new Date()

			let timeDiff = now - x
			timeDiff /= 1000

			const seconds = Math.round(timeDiff)
			timeDiff = Math.floor(timeDiff / 60)

			const minutes = Math.round(timeDiff % 60)
			timeDiff = Math.floor(timeDiff / 60)

			const hours = Math.round(timeDiff % 24)
			timeDiff = Math.floor(timeDiff / 24)

			let days = Math.round(timeDiff % 365)
			timeDiff = Math.floor(timeDiff / 365)

			const years = timeDiff;

			if (years > 0) {
				return this.$tc("yearsAgo", years, { count: years });
			} else if (days > 0) {
				return this.$tc("daysAgo", days, { count: days });
			} else if (hours > 0) {
				return this.$tc("hoursAgo", hours, { count: hours });
			} else if (minutes > 0) {
				return this.$tc("minutesAgo", minutes, { count: minutes });
			} else if (seconds > 0) {
				return this.$tc("secondsAgo", seconds, { count: seconds });
			}

			return this.$t('justNow');
		},
		// Method for creating dummy notification time
		randomDate({hr, min, sec}) {
			const date = new Date()

			if (hr) date.setHours(date.getHours() - hr)
			if (min) date.setMinutes(date.getMinutes() - min)
			if (sec) date.setSeconds(date.getSeconds() - sec)

			return date
		},
		async markAsRead(index) {
			const role = this.$store.state.auth.role;
			const notification = this.unreadNotifications[index];
			await this.$http.post(`/${role}/notification/set-status-read?id=${notification.id}`)
				.then(() => {
					this.unreadNotifications.splice(index, 1);
				});
		},
		async markAllAsRead() {
			const role = this.$store.state.auth.role;

			await this.$http.post('/' + role + '/notification/mark-everything-as-read')
				.then(() => {
					this.unreadNotifications = [];
				});
		}
	}
}

</script>

<style lang="scss" scoped>
@import "@/assets/scss/vuexy/_variables.scss";

.notification-dropdown {
	.notification {
		&__right {
			display: flex;
			flex-direction: column;
			align-items: center;
		}

		&__close {
			margin-top: 11px;
			cursor: pointer;
		}
	}

	&__markall {
		display: flex;
		justify-content: center;
		align-items: center;
		border-top: 1px solid #888888;
		font-size: 16px;
		padding: 20px 20px;
		color: $primary;
		cursor: pointer;
		transition: background-color 0.3s ease;

		&:hover {
			background-color: #eaeaea;
		}
	}
}
</style>
